var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpublished24PxBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unpublished-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-\\u6CA1\\u6709list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assessments-unpublished",
    transform: "translate(-1461.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(1460.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unpublished-24px",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94,5.12 L6.49,3.66 C8.07,2.61 9.96,2 12,2 C17.52,2 22,6.48 22,12 C22,14.04 21.39,15.93 20.34,17.51 L18.88,16.05 C19.59,14.86 20,13.48 20,12 C20,7.59 16.41,4 12,4 C10.52,4 9.14,4.41 7.94,5.12 Z M17.66,9.53 L16.25,8.12 L13.6,10.77 L15.01,12.18 L17.66,9.53 Z M19.78,22.61 L17.51,20.34 C15.93,21.39 14.04,22 12,22 C6.48,22 2,17.52 2,12 C2,9.96 2.61,8.07 3.66,6.49 L1.39,4.22 L2.8,2.81 L21.18,21.19 L19.78,22.61 Z M16.06,18.88 L12.18,15 L10.59,16.59 L6.35,12.35 L7.76,10.94 L10.59,13.77 L10.77,13.59 L5.12,7.94 C4.41,9.14 4,10.52 4,12 C4,16.41 7.59,20 12,20 C13.48,20 14.86,19.59 16.06,18.88 Z",
    id: "\\u5F62\\u72B6",
    fill: "#0E78D5",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublished24PxBlue);
export default __webpack_public_path__ + "static/media/unpublished-24px-blue.49cd34c8.svg";
export { ForwardRef as ReactComponent };